export class StreamInfo {
    public id: string;
    public url: string;
    public headerName: string;
    public headerValue: string;
    constructor(obj: any) {
        this.id = obj?.id;
        this.url = obj?.url;
        this.headerName = obj?.headerName;
        this.headerValue = obj?.headerValue;
    }
}
